export default __webpack_public_path__ + "static/media/IMG_20211224_221939.8f391a4d.png";